/* aIn is TAB Separated */
let getTransformedTSV = (aIn) => {

    let sPrefixChartId = "chart"

    function runParseMulti(aIn) {

      let aOutMap = {};//index of sTitle in aOut
      let aOut = []
      aIn.split("\n").forEach((sIn, i) => {

        let aForEach = sIn.split('\t')

        const sTitle = aForEach.shift()
        let oCount, oValName, isPushOut = false;
        //new oCount
        if (typeof aOutMap[sTitle] === "undefined") {
          oValName = "data0"
          oCount = {sTitle: sTitle, aTitle: [sTitle], sId: sPrefixChartId + aOut.length, aIds: [oValName]};
          aOutMap[sTitle] = {index: aOut.length, count: 1};
          isPushOut = true;
        }
        //reuse oCount
        else {
          oValName = "data" + aOutMap[sTitle].count++
          oCount = aOut[aOutMap[sTitle].index]
          oCount.aIds.push(oValName)
        }
        oCount[oValName] = {}

        /* generates the data */
        aForEach.forEach((val) => {
          if (val.length === 0) {
            return;
          }
          else if (typeof oCount[oValName][val] !== "number") {
            if (isPushOut)
              oCount.aTitle.push(val) //push title for first one
            oCount[oValName][val] = 1;
          } else {
            oCount[oValName][val]++
          }
        });

        //quick n dirty push
        if (isPushOut) {
          aOut.push(oCount)
        }

      });


      /* oAOut is what google chart needs */
      /* use for per line*/
      let oAOut = []
      aOut.forEach((oVal) => {
        let aTitle = oVal.aTitle
        // let aDataLine = oVal.aIds[0];
        let aData = oVal.aIds.map(aDataLine => {

          let aTmp = [aDataLine];
          for (let i = 1; i < aTitle.length; i++) {
            aTmp.push(oVal[aDataLine][aTitle[i]])
          }
          return aTmp
        });
        aData.unshift(aTitle)//add header to aData
        let tmp = {
          sChartId: oVal.sId,
          sTitle: oVal.sTitle,
          // aData: [aTitle, aData.flat()]. flat is too new
          aData: aData
        }

        oAOut.push(tmp)

      })//end oAOUT
      // return oAOut[0].aData;
      return oAOut;

    }//runParseMulti
    return runParseMulti(aIn);


  }
; //end on init

function drawStackedBarChart(data, sTitle, sChartId) {
  let options_fullStacked = {
    title: sTitle,
    isStacked: 'percent',
    height: 400,
    legend: {position: 'top', maxLines: 3},
    hAxis: {
      minValue: 0,
      ticks: [0, .25, .5, .75, 1]//% shown
    },
    animation: {
      duration: 300,
      easing: 'out'
    }
  };

  let chart = new google.visualization.BarChart(document.getElementById(sChartId));

  google.visualization.events.addListener(chart, 'ready', function () {

    var image = new Image();
    image.src = chart.getImageURI()
    var w = window.open();
    w.document.write(image.outerHTML);
    // w.document.URL=chart.getImageURI()
    // console.log(chart.getImageURI())
    $('#chartPrint').html("")
  });
  chart.draw(data, options_fullStacked);
}

/* draw stacked bar chart */
function drawStackedBarChartPercentWithDashboard(aData, sTitle, sChartId) {

  let data = google.visualization.arrayToDataTable(aData);
  let dashboard = new google.visualization.Dashboard(
    document.getElementById(sChartId));

  let controlWrapper = new google.visualization.ControlWrapper({
    'controlType': 'CategoryFilter',
    'containerId': sChartId + "Control",
    'options': {
      'filterColumnIndex': 0,
      'ui': {
        label: 'Filter dataset:'
      }
    }

  });

  let options_fullStacked = {
    title: sTitle,
    isStacked: 'percent',
    height:"400",
    legend: {position: 'top', maxLines: 3},
    hAxis: {
      minValue: 0,
      ticks: [0, .25, .5, .75, 1]//% shown
    },
    animation: {
      duration: 300,
      easing: 'out'
    }
  };
  //chart vs visualization. google has terrible docs
  let chartWrapper = new google.visualization.ChartWrapper({
    containerId: sChartId,
    chartType: "BarChart",
    options: options_fullStacked
  });
  dashboard.bind(controlWrapper, chartWrapper)
  dashboard.draw(data);

  let fnOnReady = function () {
    /* bind sort controls */
    let fnSortAsc = (oEvent) => {
      // this.data.addColumn('string', 'hi')
      var data = this.data
      //sorts first issue is sorts by number not percent
      data.sort([{column: 1, desc: false}]);
      // this.data.addRow(['data4', 10, 5])
      this.chart.draw()
      oEvent.currentTarget.disabled = true
    }
    let $sort = $(`#${sChartId}Sort`);
    $sort.click(fnSortAsc);
    $sort.removeClass("d-none")
    this.$sort = $sort

    this.fnModalAdd = (oEvent) => {
      try {

        let data = this.data
        let rRegex = new RegExp(`(\\w+)[,\\t](\\d+[,\\t]?){${data.ng.length - 1}}`);
        let sRow = this.$modalInput.val()
        if (!rRegex.test(sRow)) {
          //add err msg / refactor to vue state!
          this.$validAlertModel.html(this.$alertTemplate.clone().addClass('show').removeAttr('id'))
          return
        }
        let aRow = sRow.split(/[\t|,]/)
        let sHeader = aRow.shift();
        aRow = aRow.map(num => parseFloat(num))
        aRow.unshift(sHeader)
        this.data.addRow(aRow)
        this.chart.draw()
        this.controlWrapper.draw()

        this.$docsModal.modal('hide')
        this.$sort.attr('disabled', false)
      } catch (e) {
        alert(e)
        console.log(e)
      }

    }
    //quick n dirty:
    this.$alertTemplate = $('#validAlert')
    this.$validAlertModel = $('#validAlertModel')
    this.$modalSubmit = $("#modalSubmit")
    this.$modalInput = $("#modalInput")
    this.$docsModal = $("#docsModal")

    //from a,b. n
    function linspace(a, b, n) {
      if (typeof n === "undefined") n = Math.max(Math.round(b - a) + 1, 1);
      if (n < 2) {
        return n === 1 ? [a] : [];
      }
      var i, ret = Array(n);
      n--;
      for (i = n; i >= 0; i--) {
        ret[i] = (i * b + (n - i) * a) / n;
      }
      return ret;
    }

    let fnLinkOpenAddModal = (oEvent) => {
      let data = this.data
      let sHeader = `data${data.hc.length}`
      let x = 3;
      let aTmp = linspace(x, x + data.ng.length - 2, data.ng.length - 1)
      aTmp.unshift(sHeader)

      this.$modalInput.val(aTmp)
      this.$modalSubmit.off("click.modalsubmit")
      this.$modalSubmit.on("click.modalsubmit", this.fnModalAdd)
    }

    let $add = $(`#${sChartId}Add`);
    $add.click(fnLinkOpenAddModal);
    $add.removeClass("d-none")


    /* */
    let fnLinkOpenScreenshotModal = (oEvent) => {
      let data = this.data
      drawStackedBarChart(data, data.ng[0].label, "chartPrint")
    }
    let $screenshot = $(`#${sChartId}Screenshot`);
    $screenshot.click(fnLinkOpenScreenshotModal);
    $screenshot.removeClass("d-none")


  }.bind({data: data, chart: chartWrapper, controlWrapper:controlWrapper});
  google.visualization.events.addListener(dashboard, 'ready', fnOnReady);


}

function drawStackedBarChartPercent(aData, sTitle, sChartId) {

  var data = google.visualization.arrayToDataTable(aData);

  var options_fullStacked = {
    // title: "Operative Care and Surgery - Medical Audit Report",
    title: sTitle,
    isStacked: 'percent',
    height: 400,
    legend: {position: 'top', maxLines: 3},
    hAxis: {
      minValue: 0,
      ticks: [0, .25, .5, .75, 1]//% shown
    }
  };
  //chart vs visualization. google has terrible docs
  var chart = new google.visualization.BarChart(document.getElementById(sChartId));

  chart.draw(data, options_fullStacked);
}

/* spreadsheet query stuff */
function drawChartsFromSheets() {
  // var queryString = encodeURIComponent('SELECT A, H, O, Q, R, U LIMIT 5 OFFSET 8');
  // var queryString = encodeURIComponent('SELECT A, B LIMIT 1 offset 1');//todo group by
  //sheet 1 / default
  var sUrl = "https://docs.google.com/spreadsheets/d/1PJl2i06p-zcJlMa7PHGRS8Qs3uRnL9v7t8jejQqQTfI/edit#gid=0"

  //private / restricted
  // var sUrl = "https://docs.google.com/spreadsheets/d/10F24IEDv97uMB7A-0yUCVjyoGIZpSV_i1yXjxEoUMtQ/edit#gid=0"
  //sheets 4 special
  // var sUrl = "https://docs.google.com/spreadsheets/d/1PJl2i06p-zcJlMa7PHGRS8Qs3uRnL9v7t8jejQqQTfI/edit#gid=0"
  // var queryString = 'SELECT A, B, C limit 2';//todo group by make more eff using a query
  var query = new google.visualization.Query(
    sUrl);
  if (typeof queryString === "string")
    query.setQuery(queryString)
  query.send(handleQueryResponse);
}

function getStringParsedGoogleResponse(data) {
  let aTsvArray = data.og.map(oRow => {
    //quick n dirty
    let sTsv = oRow.c.filter((oFilter) => {
      if (oFilter !== null && oFilter.v !== null) {
        return true
      }
      return false
    }).map(oMap => oMap.v).join('\t')

    return sTsv
  })

  return getTransformedTSV(aTsvArray.join('\n'))

}

function handleQueryResponse(response) {
  if (response.isError()) {
    alert('Error in query: ' + response.getMessage() + ' ' + response.getDetailedMessage());
    return;
  }
  let data = response.getDataTable();

  /*overly complicated way... sheets 1 / 3 */
  var oDataS = getStringParsedGoogleResponse(data)
  oDataS.forEach(oData => {
    drawStackedBarChartPercentWithDashboard(oData.aData, oData.sTitle, oData.sChartId)
  })

  /* sheets 4 1946370761 */
  //   var options_fullStacked = {
  //   title: "Sheet 4",
  //   isStacked: 'percent',
  //   height: 300,
  //   legend: {position: 'top', maxLines: 3},
  //   hAxis: {
  //     minValue: 0,
  //     ticks: [0, .3, .6, .9, 1]//% shown
  //   }
  // };
  // //chart vs visualization. google has terrible docs
  // var chart = new google.visualization.BarChart(document.getElementById("chart0"));
  // debugger;
  // chart.draw(data, options_fullStacked);
}

/*doc load*/
$(function () {
  //-Load the Visualization API and the corechart package.
  google.charts.load('current', {'packages': ['corechart', "controls"]});

  //- Set a callback to run when the Google Visualization API is loaded.
  google.charts.setOnLoadCallback(drawChartsFromSheets);


});//end function
